import Icon from '../general/Icon';
import React from 'react';
import PropTypes from 'prop-types';

export const WithLoading = ({ isLoading, children, className }) => {
    if (isLoading) {
        return (
            <div className={`with-loading__container ${className}`}>
                <Icon icon="spinner" className="otrl otrl-spinner otrl-spin" />
            </div>
        );
    }
    return children;
};

WithLoading.defaultProps = {
    isLoading: false,
    children: null,
    className: '',
};

WithLoading.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
